import { compose } from 'redux';
import { curry } from 'lodash-es';
import { propEq, propFromSelector } from '../utils';
import { jsonApi } from '../http-request';

const collection = jsonApi.selectors.collection('invite_addresses');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  return {
    id: propFromResource('id'),
    base_street: propFromResource('base_street'),
    street: propFromResource('street'),
    city: propFromResource('city'),
    state: propFromResource('state'),
    zip: propFromResource('zip'),
    apt: propFromResource('apt'),
    classification: propFromResource('classification'),
    metadata: propFromResource('metadata'),
    analysis: propFromResource('analysis'),
    components: propFromResource('components'),
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));

export const hydrateFromFacade = state => facade =>
  Object.keys(facade).reduce((ret, key) => {
    ret[key] = facade[key](state);
    return ret;
  }, {});
